<div class="page-container">
    <app-loader *ngIf="isLoading"></app-loader>

    <div *ngIf="!isLoading" class="content-container">
        <used-days></used-days>
        <div class="margin-left-18">
            <h1 class="no-margin">
                <span class="title-heading">Slobodni dani – Godišnji odmori</span>
            </h1>
        </div>
        <div class="padding-bottom-20">
            <div class="margin-top-30 margin-bottom-20 margin-left-18">
                <button type="button" class="btn btn-sm btn-request-blue margin-right-7"
                    (click)="createNewHolidayRequest()"><i class="lni lni-envelope"></i> Novi zahtjev</button>
                <button type="button" class="btn btn-sm btn-live-purple margin-right-7"
                    routerLink="/kalendar-odsustva"><i class="lni lni-calendar"></i> Kalendar odsustva</button>
                <button type="button" class="btn btn-sm btn-live-green" (click)="showUsedDays()"><i
                        class="lni lni-checkmark-circle"></i> Uvid u iskorišćene slobodne dane</button>
            
                <button type="button" class="btn btn-sm btn-live-blue" routerLink="/podesavanja" *ngIf="permissionArray.includes(userId)"><i class="lni lni-cog"></i> Podešavanja</button>
            </div>
        </div>
        <div *ngIf="showDashboard" class="dashboard-container">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-4">
                <div class="kanban-header kanban-header-purple">
                    <div class="media">
                        <div class="media-body"><i class="kanban-header-menu fas fa-ellipsis-v"></i>
                            <h3 class="mt-0 mb-0 kanban-header-label">ZAHTJEV</h3>
                        </div>
                    </div>
                </div>
                <div class="card-list-content mt-3" cdkDropList [id]="tracks[0].id"
                    [cdkDropListData]="tracks[0].request" [cdkDropListConnectedTo]="trackIds"
                    (cdkDropListDropped)="onTalkDrop($event)">
                    <div *ngFor="let holiday of tracks[0].request" cdkDrag
                        [cdkDragDisabled]="(!permissionArray.includes(userId) && userId != holiday.manager_id) || ['manager_reject', 'director_reject'].includes(holiday.status)"
                        class="card mb-3 kanban-card">
                        <div class="card-body" [routerLink]="['/zahtjev-pregled', holiday._id]">
                            <div class="float-right mt-n1 mb-2" style="width: 100%">
                                <div class="media">
                                    <div class="media-body" style="margin-top:2px;">
                                        <span id="projectSpan"
                                            class=" badge badge-success project-preview text-wrap font-size-12 badge-period">Period:
                                            {{holiday.date_from | date:'dd.MM.yyyy' }} do {{holiday.date_to |
                                            date:'dd.MM.yyyy'}}
                                        </span>

                                        <div>
                                            <span id="projectSpan"
                                                class=" badge badge-success project-preview text-wrap font-size-12 badge-period">
                                                Zaposleni: {{holiday.fullName.first_name}} {{holiday.fullName.last_name}}
                                            </span>
                                        </div>

                                        <div>
                                            <span style="float: right"
                                                [ngClass]="{'badge badge-danger project-preview text-wrap badge-color': holiday.statusBadge === 'ZAHTJEV ZA PONIŠTENJE ODMORA' || holiday.statusBadge === 'Menadžer odobrio poništenje zahtjeva', 
                                            'badge badge-info mr-n2': !(holiday.statusBadge === 'ZAHTJEV ZA PONIŠTENJE ODMORA' || holiday.statusBadge === 'Menadžer odobrio poništenje zahtjeva')}">
                                                {{holiday.statusBadge}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="float-right mr-n2"></div>

                            <p style="font-size: 14px;" class="mt-2">{{holiday.doc_name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-4">
                <div class="container kanban-header kanban-header-orange">
                    <div class="media">
                        <div class="media-body"><i class="kanban-header-menu fas fa-ellipsis-v"></i>
                            <h3 class="mt-0 mb-0 kanban-header-label">ODOBRIO MENADŽER</h3>
                        </div>
                    </div>
                </div>
                <div class="card-list-content mt-3 full-width" cdkDropList [id]="tracks[1].id"
                    [cdkDropListData]="tracks[1].request" [cdkDropListConnectedTo]="trackIds"
                    (cdkDropListDropped)="onTalkDrop($event)">
                    <div *ngFor="let holiday of tracks[1].request" cdkDrag class="card mb-3 kanban-card"
                        [cdkDragDisabled]="(!permissionArray.includes(userId) && userId != holiday.manager_id) || ['employee_reject', 'manager_reject', 'director_reject'].includes(holiday.status)">
                        <div class="card-body" [routerLink]="['/zahtjev-pregled', holiday._id]">
                            <div class="float-right mt-n1 mb-2" style="width: 100%">
                                <div class="media">
                                    <div class="media-body" style="margin-top:2px;">
                                        <span id="projectSpan"
                                            class=" badge badge-success project-preview text-wrap font-size-12 badge-period">Period:
                                            {{holiday.date_from | date:'dd.MM.yyyy' }} do {{holiday.date_to |
                                            date:'dd.MM.yyyy'}}
                                        </span>

                                        <div>
                                            <span id="projectSpan"
                                                class=" badge badge-success project-preview text-wrap font-size-12 badge-period">
                                                Zaposleni: {{holiday.fullName.first_name}} {{holiday.fullName.last_name}}
                                            </span>
                                        </div>

                                        <div>
                                            <span style="float: right"
                                                [ngClass]="{'badge badge-danger project-preview text-wrap badge-color': holiday.statusBadge === 'ZAHTJEV ZA PONIŠTENJE ODMORA' || holiday.statusBadge === 'Menadžer odobrio poništenje zahtjeva', 
                                            'badge badge-info mr-n2': !(holiday.statusBadge === 'ZAHTJEV ZA PONIŠTENJE ODMORA' || holiday.statusBadge === 'Menadžer odobrio poništenje zahtjeva')}">
                                                {{holiday.statusBadge}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right mr-n2"></div>
                            <p style="font-size: 14px;" class="mt-2">{{holiday.doc_name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-4">
                <div class="col-md-12 no-padding" class="kanban-header kanban-header-green">
                    <div class="media">

                        <div class="media-body"><i class="kanban-header-menu fas fa-ellipsis-v"></i>
                            <h3 class="mt-0 mb-0 kanban-header-label">ODOBRIO IZVRŠNI DIREKTOR</h3>
                        </div>
                    </div>

                </div>
                <div class="card-list-content mt-3 full-width" cdkDropList [id]="tracks[2].id"
                    [cdkDropListData]="tracks[2].request" [cdkDropListConnectedTo]="trackIds"
                    (cdkDropListDropped)="onTalkDrop($event)">
                    <div *ngFor="let holiday of tracks[2].request" cdkDrag class="card mb-3 kanban-card"
                        [cdkDragDisabled]="!permissionArray.includes(userId)|| ['employee_reject', 'manager_reject', 'director_reject'].includes(holiday.status)">
                        <div class="card-body" [routerLink]="['/zahtjev-pregled', holiday._id]">
                            <div class="float-right mt-n1 mb-2" style="width: 100%">
                                <div class="media">
                                    <div class="media-body" style="margin-top:2px;">
                                        <span id="projectSpan"
                                            class=" badge badge-success project-preview text-wrap font-size-12 badge-period">Period:
                                            {{holiday.date_from | date:'dd.MM.yyyy' }} do {{holiday.date_to |
                                            date:'dd.MM.yyyy'}}
                                        </span>

                                        <div>
                                            <span id="projectSpan"
                                                class=" badge badge-success project-preview text-wrap font-size-12 badge-period">
                                                Zaposleni: {{holiday.fullName.first_name}} {{holiday.fullName.last_name}}
                                            </span>
                                        </div>

                                        <div>
                                            <span style="float: right"
                                                [ngClass]="{'badge badge-danger project-preview text-wrap badge-color': holiday.statusBadge === 'ZAHTJEV ZA PONIŠTENJE ODMORA' || holiday.statusBadge === 'Menadžer odobrio poništenje zahtjeva', 
                                            'badge badge-info mr-n2': !(holiday.statusBadge === 'ZAHTJEV ZA PONIŠTENJE ODMORA' || holiday.statusBadge === 'Menadžer odobrio poništenje zahtjeva')}">
                                                {{holiday.statusBadge}}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="float-right mr-n2"></div>
                            <p style="font-size: 14px;" class="mt-2">{{holiday.doc_name}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>